import { FlowHumanTaskBlockConfigSchema } from 'flow-schema';
import { z } from 'zod';

import {
  BaseFlowBlockSchema,
  BlockType,
  ProducedType,
  returnTypeSchema,
} from '../base/baseSchema.js';

export const HumanTaskBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.HumanTask),
  config: FlowHumanTaskBlockConfigSchema,
  returnType: returnTypeSchema(ProducedType.HumanTask),
});
export type HumanTaskBlock = z.infer<typeof HumanTaskBlockSchema>;
